import { render } from "./HelpFeedbackTile.vue?vue&type=template&id=1c37f462"
import script from "./HelpFeedbackTile.vue?vue&type=script&lang=js"
export * from "./HelpFeedbackTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__